<script setup lang="ts">
import type { PropertySearchCriteria } from '@@/shared/property/search-criteria';

const modelValue = defineModel<PropertySearchCriteria['radius']>({ required: true });
</script>

<template>
  <IadRadioGroup
    v-model="modelValue"
    :label="$t(`property_serp.filters.location_radius`)"
  >
    <IadRadio :label="$t('property_serp.filters.exact_location')" />
    <IadRadio
      v-for="radius in [`5km`, `10km`, `15km`, `20km`]"
      :key="radius"
      :value="radius"
      :label="`+ ${radius}`"
    />
  </IadRadioGroup>
</template>
